import { PlanType } from "~proto/modal_server/proto/public_api";

export const getPlanName = (planType: PlanType): string => {
  if (planType === PlanType.PLAN_STARTER) {
    return "Starter";
  } else if (planType === PlanType.PLAN_TEAM) {
    return "Team";
  } else if (planType === PlanType.PLAN_ENTERPRISE) {
    return "Enterprise";
  } else {
    return "Unrecognized Plan";
  }
};
